import Axios, { AxiosError } from 'axios';
import { ApiBaseUrl } from '../configuration';
import { IFetchResponse } from '../types/IFetchResponse';


export abstract class TranslatorService {
    protected static axios = Axios.create({
        baseURL: ApiBaseUrl
    });



    static async queryApiPost<TEntity>(apiEndpoint: string, body: any): Promise<IFetchResponse<TEntity>> {
        try {
            let response = await this.axios.post<TEntity>(ApiBaseUrl + apiEndpoint, body);
            return {
                ok: response.status <= 299,
                statusCode: response.status,
                data: response.data
            };    
        } catch (err) {
            let error = err as AxiosError;
            return {
                ok: false,
                statusCode: error.response?.status ?? 500,
                //messages: (error.response?.data as IMessages).messages,
            }
        }
    }

    static async queryApiGet<TEntity>(apiEndpoint: string, params: any): Promise<IFetchResponse<TEntity>> {
        try {
            let response = await this.axios.get<TEntity>(ApiBaseUrl + apiEndpoint, {params: params});
            return {
                ok: response.status <= 299,
                statusCode: response.status,
                data: response.data
            };    
        } catch (err) {
            let error = err as AxiosError;
            return {
                ok: false,
                statusCode: error.response?.status ?? 500,
                //messages: (error.response?.data as IMessages).messages,
            }
        }
    }

}